import { Controller } from 'stimulus';
import { createRepository } from './bookmark/repository';
import { createViewModel } from './bookmark/view_model';
export default class default_1 extends Controller {
    connect() {
        this.repository = createRepository({ endpoint: this.endpoint });
        this.vm = createViewModel({
            el: this.containerTarget,
            repository: this.repository,
        });
    }
    disconnect() {
        this.vm.dispose();
        this.vm = null;
        this.repository.dispose();
        this.repository = null;
    }
    onVideoTimeUpdate(event) {
        if (this.vm) {
            if (event.target instanceof HTMLVideoElement) {
                this.vm.setCurrentTime(event.target.currentTime);
            }
        }
    }
    get endpoint() {
        return this.data.get('endpoint');
    }
}
default_1.targets = ['container'];
